import React, { useEffect } from "react";
import Header from "../../component/header/Header";
import { Box } from "@mui/material";
import { ReactComponent as GrafIcon } from "../../assets/CardListIcon/Sparkline.svg";
import { ReactComponent as CardIcon2 } from "../../assets/CardListIcon/cardIcon2.svg";
import { ReactComponent as CardIcon3 } from "../../assets/CardListIcon/cardIocn3.svg";
import PiceChart from "../../component/dashboard/PiceChart";
import CardList from "../../component/dashboard/CardList";
import TableDashboard from "../../component/dashboard/TableDashboard";
import Graph from "../../component/dashboard/Graph";
import sensorsData from "../../utils/dashboard/sensorsData.json";
import registrationsData from "../../utils/dashboard/registrationsData.json";
import pieData from "../../utils/dashboard/pieData.json";
import { fetchCompanies } from "../../features/company/companyThunk";
import { useDispatch } from "react-redux";

const dataHorizontal = [
  {
    title: "Totale produzione",
    value: "80.5t",
    percentage: 8.2,
    isIncrease: true,
    color: "green",
    icons: <GrafIcon />,
  },
  {
    title: "Produzioni",
    value: "6",
    percentage: 86.6,
    isIncrease: false,
    color: "red",
    icons: <CardIcon2 />,
  },
  {
    title: "Non conformità rilevate",
    value: "30",
    percentage: 73.9,
    isIncrease: true,
    color: "green",
    icons: <CardIcon3 />,
  },
];
const dataVertical = [
  {
    title: "Totale prodotto in stock",
    value: "500.2t",
    percentage: 8.2,
    isIncrease: true,
    color: "green",
    icons: <GrafIcon />,
  },
  {
    title: "Totale Ordini evasi",
    value: "86.6t",
    percentage: 86.6,
    isIncrease: false,
    color: "red",
    icons: <CardIcon2 />,
  },
  {
    title: "Area coltivata",
    value: "10.000mq",
    percentage: 73.9,
    isIncrease: true,
    color: "green",
    icons: <CardIcon3 />,
  },
];



const columnsTable1 = [
  { label: "ID Sensore", field: "sensorId", width: 405 },
  { label: "Tipo", field: "type", width: 160 },
  { label: "Ultima rilevazione", field: "lastReading", width: 200 },
  { label: "Stato", field: "status", width: 100 },
];
const columnsTable2 = [
  { label: "Contract", field: "contract", width: 405 },
  { label: "ID Produzione", field: "productionId", width: 160 },
  { label: "Data", field: "date", width: 160 },
  { label: "Status", field: "status", width: 100 },
];

const Dashboard = () => {
  const dispatch = useDispatch()
  useEffect(() => {
    dispatch(fetchCompanies())
  },[])
  return (
    <>
      {/* <Header /> */}
      <Box>
        <CardList data={dataHorizontal} direction="horizontal" />
      </Box>
      <Box sx={{ paddingTop: "120px" }}>
        <Box className="graphCardRow">
          <Box className="graphCardCol">
            <Graph />
          </Box>
          <Box className="graphCardCol">
            <Box className="PiceChart_container">
            <PiceChart pieData={pieData} />
            </Box>
          </Box>

          <Box className="graphCardCol">
            <CardList data={dataVertical} direction="vertical" />
          </Box>
        </Box>
      </Box>

      <Box className="tableDashboard">
        <Box sx={{ width: "100%" }}>
          <TableDashboard
            sensorsData={sensorsData}
            columns={columnsTable1}
            title={"Sensori"}
            next={"Visulizza tutti"}
          />
        </Box>
        <Box sx={{ width: "100%" }}>
          <TableDashboard
            sensorsData={registrationsData}
            columns={columnsTable2}
            title={"Registrazioni dati"}
            next={"Vedi tutti"}
          />
        </Box>
      </Box>
    </>
  );
};

export default Dashboard;
